import { useCallback } from 'react'

import { useAppDispatch } from '@/redux/rootReducer'
import { joinMeeting } from '@/redux/reducers/consultation.reducer'

import type { AuthUser } from '@/core/classes/Auth'

type UseJoinMeetingParams = {
  consultationId?: string
  authUser?: AuthUser | null
}

export function useJoinMeeting({ consultationId, authUser }: UseJoinMeetingParams) {
  const dispatch = useAppDispatch()

  const handleJoinMeeting = useCallback(() => {
    if (!consultationId || !authUser?._id) return

    dispatch(joinMeeting({ roomOrConsultationId: consultationId, userId: authUser._id, meetingType: 'visioConference' }))
  }, [dispatch, consultationId, authUser])

  return { handleJoinMeeting }
}
